import * as types from '../actions/ActionTypes';

const initialState = {
  palette: null,
  isPaletteLoading: false,
  isColorsLoading: false,
  query: {},
  category: {}
};

export function colors(state = initialState, action) {
  switch (action.type) {
  case types.COLOR_PALETTE_REQUEST:
    return Object.assign({}, state, {
      isPaletteLoading: true
    });
  case types.COLOR_PALETTE_RECEIVE:
    return Object.assign({}, state, {
      isPaletteLoading: false,
      palette: action.payload.reduce((memo, color) => {
        memo[color.id] = {
          name: color.name,
          value: color.value
        };
        return memo;
      }, {})
    });
  case types.COLORS_REQUEST:
    return Object.assign({}, state, {
      isColorsLoading: true
    });
  case types.COLORS_RECEIVE: {
    const query = Object.assign({}, state.query);
    const category = Object.assign({}, state.category);

    action.payload.forEach(entry => {
      let obj;

      if (entry.color_type_id === 'brandwatch_query') {
        obj = query;
      } else if (entry.color_type_id === 'brandwatch_category') {
        obj = category;
      }

      if (entry.color_id) {
        obj[entry.id] = entry.color_id;
      } else {
        delete obj[entry.id];
      }
    });

    return Object.assign({}, state, {
      isColorsLoading: false,
      query,
      category
    });
  }
  default:
    return state;
  }
}
